import { getFileExtension } from "./archiveDocumentUtils";

const PREVIEWABLE_EXTENSIONS = new Set([
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".bmp",
]);

const NON_BROWSER_IMAGE_EXTENSIONS = new Set([
  ".heic",
  ".heif",
  ".tif",
  ".tiff",
]);

export const NAS_VIEW_UNAVAILABLE_MESSAGE =
  "This file type is not supported for view. Use Download.";

const isBrowserPreviewableMime = (mimeType?: string | null): boolean => {
  const mime = (mimeType ?? "").toLowerCase().trim();
  if (!mime) {
    return false;
  }

  if (mime.includes("pdf")) {
    return true;
  }

  if (!mime.startsWith("image/")) {
    return false;
  }

  return (
    !mime.includes("heic") &&
    !mime.includes("heif") &&
    !mime.includes("tiff") &&
    !mime.includes("tif")
  );
};

export const isNasPreviewableFile = (
  fileName?: string | null,
  mimeType?: string | null
): boolean => {
  if (isBrowserPreviewableMime(mimeType)) {
    return true;
  }

  const extension = getFileExtension(fileName);
  if (!extension) {
    return false;
  }

  if (NON_BROWSER_IMAGE_EXTENSIONS.has(extension)) {
    return false;
  }

  return PREVIEWABLE_EXTENSIONS.has(extension);
};
